export const OPERATOR_APPLICATION_AUTH_ROUTE_NAME = "auth";
export const OPERATOR_APPLICATION_ROOT_ROUTE_NAME = "root";

export const OPERATOR_APPLICATION_DIALOGS_ROUTE_NAME = "dialogs";
export const OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID = "listId";
export const OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN = "main";


export const OPERATOR_APPLICATION_DIALOG_ROUTE_NAME = "dialog";
export const OPERATOR_APPLICATION_DIALOG_ROUTE_USERNAME = "username";

export const OPERATOR_APPLICATION_NEWS_ROUTE_NAME = "news";

export const OPERATOR_APPLICATION_CONFIG_ROUTE_NAME = "config";
export const OPERATOR_APPLICATION_INITIATE_CHAT_ROUTE_NAME = "initiateChat";